import * as Tone from 'tone';

// Brickwall limiter — clamp peaks above a threshold without colorful
// compression. Useful as the last insert on a louder channel before the
// master glue chain.

export default {
    id: 'limiter',
    name: 'Limit',
    color: '#ef596f',
    create() {
        const node = new Tone.Limiter(-1);
        return {
            node,
            params: [
                { label: 'Ceil', unit: 'dB', min: -24, max: 0, step: 0.5,
                  get: () => node.threshold.value, set: v => { node.threshold.value = v; } },
            ],
            dispose() { node.dispose(); },
        };
    },
};
